import type {
  AppVideoMediaType,
  AppVideoPoster,
  AppVideoPosterResponsive,
  AppVideoSrc,
} from '@/app/components/media/app-video/types';

export const isResponsivePoster = (
  poster: AppVideoPoster
): poster is AppVideoPosterResponsive =>
  'mobileSrc' in poster && 'desktopSrc' in poster;

export const normalizeVideoSrc = (video: AppVideoSrc | string): AppVideoSrc => {
  if (typeof video === 'string') {
    return { mobile: video, desktop: video };
  }

  return {
    mobile: video.mobile,
    desktop: video.desktop || video.mobile,
  };
};

export const resolveMediaType = (desktopMedia: string): AppVideoMediaType =>
  window.matchMedia(desktopMedia).matches ? 'desktop' : 'mobile';
